import {MetaTitleDesc} from "./meta";
import DocumentMeta from "react-document-meta";
import {Link} from "react-router-dom";

export default () => {
    const title = 'Полезная информация';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <ul>
                        <li><Link to='/useful-information/standarts'>ПЕРЕЧЕНЬ СУЩЕСТВУЮЩИХ СТАНДАРТОВ В СФЕРЕ ТУРИСТСКО-ЭКСКУРСИОННОГО ОБСЛУЖИВАНИЯ</Link></li>
                        <li><Link to='/useful-information/cuts'>Общепринятые сокращения</Link></li>
                    </ul>
                </div>
            </div>
        </>
    );
}